import React from 'react';

const CircularLoader = ({ circleColor = "text-gray-300", spinnerColor = "text-cyan-600" }) => {
    return (
        <div className="flex items-center justify-center w-10">
            <svg className={`h-8 w-8 animate-spin ${spinnerColor}`} viewBox="0 0 50 50">
                <circle
                    className={circleColor}
                    fill="none"
                    strokeWidth="5"
                    stroke="currentColor"
                    cx="25"
                    cy="25"
                    r="20"
                />
                <path
                    className={spinnerColor}
                    fill="none"
                    strokeWidth="5"
                    strokeLinecap="round"
                    stroke="currentColor"
                    d="M25 5a20 20 0 1 1 0 40a20 20 0 0 1 0-40"
                    strokeDasharray="31.4"
                    strokeDashoffset="15.7"
                    style={{
                        transition: 'stroke-dashoffset 1s ease-in-out',
                    }}
                />
            </svg>
        </div>
    );
};

export default CircularLoader;
